import { Dispatch } from "redux";
import { errorHandler } from "../../helpers/Functions";
import { Pagination } from "../../Interfaces/Interfaces";
import AdministratorService from "../../services/AdministratorService";
import IdentityServices from "../../services/AuthService";
export const getAdmins = (data: Pagination) => {
  const api = new AdministratorService().getAdmins(data);
  var payload = {};
  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        dispatch({
          type: "ADMINISTRATORS",
          payload: res,
        });
      })
      .catch(() => {
        dispatch({
          type: "ADMINISTRATORS",
          payload: payload,
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const queryAdmins = (data: Pagination) => {
  const api = new AdministratorService().queryAdmins(data);
  var payload = {};
  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        dispatch({
          type: "QUERY_ADMINISTRATORS",
          payload: res,
        });
      })
      .catch(() => {
        dispatch({
          type: "QUERY_ADMINISTRATORS",
          payload: payload,
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const createAdmin = (data: any) => {
  const api = new AdministratorService().createAdmin(data);
  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch((err: any) => {
        dispatch({
          type: "ALERT",
          payload: {
            message: errorHandler(err),
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const updateAdmin = (data: any) => {
  const api = new AdministratorService().updateAdmin(data);
  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "ALERT",
            payload: {
              message: "Successful",
              successful: true,
            },
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch((err: any) => {
        dispatch({
          type: "ALERT",
          payload: {
            message: errorHandler(err),
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

export const getAdmin = (data: any) => {
  const api = new AdministratorService().getAdmin(data);
  return (dispatch: Dispatch) => {
    api
      .then((res: any) => {
        if (res.successful) {
          dispatch({
            type: "SINGLE_ADMINISTRATOR",
            payload: res.result,
          });
        } else {
          dispatch({
            type: "ALERT",
            payload: {
              message: errorHandler(res),
              successful: false,
            },
          });
        }
      })
      .catch((err: any) => {
        dispatch({
          type: "ALERT",
          payload: {
            message: errorHandler(err),
            successful: false,
          },
        });
      })
      .finally(() => {
        dispatch({
          type: "LOADING",
          payload: false,
        });
      });
  };
};

// export const SwitchAdminAction = (data: any) => {
//   const api = new IdentityServices().activateAndDeactivateAdminService(data);
//   // console.log("working");
//   return (dispatch: Dispatch) => {
//     // console.log(dispatch);
//     api
//       .then((res: any) => {
//         if (res.successful) {
//           dispatch({
//             type: "ALERT",
//             payload: {
//               message: "Successful",
//               successful: true,
//             },
//           });
//         } else {
//           dispatch({
//             type: "ALERT",
//             payload: {
//               message: errorHandler(res),
//               successful: false,
//             },
//           });
//         }
//       })
//       .catch((err: any) => {
//         dispatch({
//           type: "ALERT",
//           payload: {
//             message: errorHandler(err),
//             successful: false,
//           },
//         });
//       })
//       .finally(() => {
//         dispatch({
//           type: "LOADING",
//           payload: false,
//         });
//       });
//   };
// };
